export default {
   courses: [],
   template: {},
   getEmailTemplatesInProgress: true,
   getEmailTemplateInProgress: false,
   updateEmailTemplateInProgress: true,
   checkBoxValues: {},
   autoEmails: [],
};
